module.exports = __webpack_public_path__ + "img/ickey_img.56a19c6d.png";